export default {
  confirmTitle: 'Confirmação',
  confirmDescription: 'Confirma a ação?',
  removeDescription: 'Deseja remover permanentemente {name}?',
  audit: {
    created: 'Informações do Cadastro',
    updatedBefore: 'Antes da Atualização',
    updatedAfter: 'Depois da Atualização',
    deleted: 'Informações antes de remover',
  },
  login: {
    resetPassword: {
      description: 'Digite abaixo o email cadastrado no sistema.',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/pt-BR/Dialog.js